import toastr from 'toastr'

function toast(type, message, title, overrides) {
  const currentOptions = toastr.options
  overrides = overrides || {}

  try {
    toastr.options =  {}

    toastr.options = {
      closeButton: true,
      closeHtml: '<i class="fa fa-times" />',
      iconClasses: {
        error: 'op-toast-error',
        info: 'op-toast-info',
        success: 'op-toast-success',
        warning: 'op-toast-warning'
      },
      positionClass: 'op-toast-offset-top-right',
      ...overrides
    }

    toastr[type](message, title)
  } finally {
    toastr.options = currentOptions
  }
}

export const notify = {
  clear: function() {
    toastr.clear()
  },

  error: function(message, title, overrides) {
    toast('error', message, title, overrides)
  },

  info: function(message, title, overrides) {
    toast('info', message, title, overrides)
  },

  success: function (message, title, overrides) {
    toast('success', message, title, overrides)
  },

  warning: function(message, title, overrides) {
    toast('warning', message, title, overrides)
  }
}
